var _defs, _path, _circle, _circle2, _path2, _path3, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMcTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #000;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49,53c-4,4-12.33,1.67-16,0l-4-8.5v-4c-1.6-.4-7-3.17-9.5-4.5l-7.5-1c-2.67,.17-8-.2-8-3,0-3.5,17-4,16.5-2-.4,1.6,1.5,3.67,2.5,4.5h9.5l1-2c3.6-4,12.17-6,16-6.5l-1.5-5-4.5,2.5c-4.4,.4-3.17-2.17-2-3.5,1.33-1.33,4.7-4,7.5-4s3.17,3,3,4.5c3.2-1.6,5,0,5.5,1,1,2.17,2.9,6.9,2.5,8.5-.4,1.6-2.17,2.67-3,3l3,5.5c7.6-2.8,14.37,1.5,14.37,5.5-9.6-3.6-17.67,3.83-20.5,8-2.8-2,.3-8.17,2.13-10.5l-3-6c-4.8,5.2-4.67,13.83-4,17.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17,
    cy: 51,
    r: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 66,
    cy: 53,
    r: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66,53l-4.5-7.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,44l-11,7h14"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17,
    cy: 51,
    r: 7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 66,
    cy: 53,
    r: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcTooltip);
export default __webpack_public_path__ + "static/media/mc_tooltip.9eca5acb59599149817797f3eadbba95.svg";
export { ForwardRef as ReactComponent };